
    import { Vue, Component, Mixins } from 'vue-property-decorator';
    import ProfileAddresses from '@rogues/ProfileAddresses/shared/profileAddresses';
    import YProfileAddressCardSimple from '@rogues/ProfileAddresses/blocks/Card/Simple/index.vue';
    import YProfileAddressEditor from '@rogues/ProfileAddressEditor/types/Modal.vue';

    interface addressEditorRef extends Vue {
        // eslint-disable-next-line no-unused-vars
        openModal(address, config): void;
        closeModal(): void;
    }

    interface removeConfirm extends Vue {
        open(): void;
        close(): void;
    }

    @Component({
        components: {
            YProfileAddressCardSimple,
            YProfileAddressEditor,
        },
    })
    /**
     * @name Simple
     */
    export default class Simple extends Mixins(ProfileAddresses) {
        /**
         * Refs types
         */
        declare $refs: {
            addressEditor: addressEditorRef;
            removeConfirm: removeConfirm;
        };

        /**
         * Open Address Editor Modal
         *
         * @param {object} address
         */
        editAddress(address: object) {
            this.$refs.addressEditor.openModal(address, this.divisionConfig);
        }

        /**
         * Remove Address
         *
         * @param {string} id - ID of address item
         */
        confirmDeleteAddress(id: string) {
            this.removeAddressId = id;
            this.$refs.removeConfirm.open();
        }

        /**
         * Close modal
         */
        closeModal() {
            this.$refs.removeConfirm.close();
            this.removeAddressId = null;
        }
    }
